export const stripThousandsFormatting = (value: string): string => value.replace(/[^\d]/g, '');

export const formatThousands = (value: string): string => {
  const digits = stripThousandsFormatting(value);
  if (!digits) return '';
  return Number(digits).toLocaleString('en-US');
};

/**
 * Where the caret should land inside `formatted` so it stays after the same
 * digit it was after before formatting (e.g. thousands separators shifting
 * around it shouldn't move it relative to the digits themselves).
 */
export const getCaretPositionAfterFormat = (
  formatted: string,
  digitsBeforeCaret: number,
): number => {
  if (digitsBeforeCaret <= 0) return 0;

  let digitsSeen = 0;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted.charAt(i))) {
      digitsSeen++;
      if (digitsSeen === digitsBeforeCaret) return i + 1;
    }
  }
  return formatted.length;
};
